import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ShuttlesService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TResponse, TShuttle } from '@shared/models';

@Component({
    'selector': 'app-shuttles',
    'templateUrl': './shuttles.page.html',
    'styleUrls': ['./shuttles.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class ShuttlesPage extends ViewBasePage implements OnInit, OnDestroy {
    public shuttles: any = [];
    public shuttlesDefinedStr: string;
    private shuttlesSubscription: any;

    constructor( private shuttlesService: ShuttlesService,
        injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_SHUTTLES);
    }

    public override async ngOnInit(): Promise<void> {
        // await this.uxHelperService.showSpinner();
        const shuttlesObservable = this.shuttlesService.getObservable();
        this.shuttlesSubscription = shuttlesObservable.subscribe((shuttles: TShuttle[]) => {
            this.shuttles = shuttles.sort((a, b) => {
                if (a.shuttleName < b.shuttleName) {
                    return -1;
                } else if (a.shuttleName > b.shuttleName) {
                    return 1;
                } else {
                    return 0;
                }
            });
            this.shuttlesDefinedStr = this.utilsService.
                useSingularOrPlural(this.shuttles.length, 'shuttle defined.', 'shuttles defined.');
            // await this.uxHelperService.hideSpinner();
        });
        this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        this.shuttlesSubscription.unsubscribe();
    }

    public initMoreMenu(): void {
        this.pushPopoverMenuItem('Show Tour', 'show-shuttles-tour');
    }

    public onAddShuttle(): void {
        this.router.navigateByUrl(`/managerSettings/shuttles/shuttle`);
    }

    public onShuttleClick(uid: string): void {
        this.router.navigateByUrl(`/managerSettings/shuttles/shuttle/${uid}`);
    }

    public async confirmDeleteShuttle(shuttle: TShuttle) {
        const question = 'Are you sure you want to delete shuttle: ' + shuttle.shuttleName + '?';
        const response = await this.uxHelperService.showAlert('Confirm Delete', question);
        if (response.okay) {
            await this.deleteShuttle(shuttle);
        }
    }

    private async deleteShuttle(shuttle) {
        await this.uxHelperService.showSpinner('Deleting.');
        await this.shuttlesService.delete(shuttle.uid);
        await this.uxHelperService.hideSpinner();
        this.uxHelperService.showToast('Shuttle has been deleted.');
    }
}
